<template>
    <div>
        <form @submit.prevent="validate">
            <div class="mb-3">
                <h5>Practice Details</h5>

                <div class="card mb-3">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>General Details</b>
                        </div>

                        <div class="form-group required">
                            <label>Practice Name</label>
                            <input type="text" name="name" data-vv-validate-on="blur" data-vv-as="name"
                                placeholder="Practice Name" v-model="value.name" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('name')
                            }">
                            <div v-show="validationErrors.has('name')" class="invalid-feedback">
                                {{ validationErrors.first('name') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Languages Speak</label>
                            <input style="opacity:0;" :class="{ 'is-invalid':  languagesSpeakHasError }">
                            <div v-show="languagesSpeakHasError" class="invalid-feedback mb-2">
                                The languages speak field is required.
                            </div>
                            <div class="row">
                                <div class="col-6 not-required" v-for="language in languages" :key="language">
                                    <input type="checkbox" :id="language" :value="language" v-model="value.languagesSpeak">
                                    <label class="ml-2" :for="language">{{ language }}</label>
                                </div>
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Practice Registration (SSM) Number</label>
                            <input type="text" name="clinicRegistrationNumber" data-vv-validate-on="blur" data-vv-as="Practice Registration (SSM) Number"
                                placeholder="Practice Registration (SSM) Number" v-model="value.clinicRegistrationNumber" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('clinicRegistrationNumber')
                            }">
                            <div v-show="validationErrors.has('clinicRegistrationNumber')" class="invalid-feedback">
                                {{ validationErrors.first('clinicRegistrationNumber') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Practice Registration (SSM) Document Upload (Optional)</label>
                            <div>
                                <div>
                                    <input id="ssmFileInput" type="file" v-validate="''" data-vv-as="Practice Registration (SSM) Document" name="ssmFileInput" :class="{'is-invalid':  validationErrors.has('ssmFileInput')}">
                                    <div v-show="validationErrors.has('ssmFileInput')" class="invalid-feedback">
                                        {{ validationErrors.first('ssmFileInput') }}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>Optometrist Details</b>
                        </div>

                        <div class="form-group required">
                            <label>Full Name</label>
                            <input type="text" name="optoFullName" data-vv-validate-on="blur" data-vv-as="full name"
                                placeholder="Full Name" v-model="value.optoFullName" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('optoFullName')
                            }">
                            <div v-show="validationErrors.has('optoFullName')" class="invalid-feedback">
                                {{ validationErrors.first('optoFullName') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>AMO Membership Number</label>
                            <input type="text" name="optoAmoMembershipNumber" data-vv-validate-on="blur" data-vv-as="AMO membership number"
                                placeholder="AMO Membership Number" v-model="value.optoAmoMembershipNumber" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('optoAmoMembershipNumber')
                            }">
                            <div v-show="validationErrors.has('optoAmoMembershipNumber')" class="invalid-feedback">
                                {{ validationErrors.first('optoAmoMembershipNumber') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>AMO Membership Document Upload (Optional)</label>
                            <div>
                                <div>
                                    <input id="optoAmoMembershipFileInput" type="file" data-vv-as="AMO Membership Document" name="optoAmoMembershipFileInput" :class="{'is-invalid':  validationErrors.has('optoAmoMembershipFileInput')}">
                                    <div v-show="validationErrors.has('optoAmoMembershipFileInput')" class="invalid-feedback">
                                        {{ validationErrors.first('optoAmoMembershipFileInput') }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Qualification</label>
                            <input type="text" name="optoQualification" data-vv-validate-on="blur" data-vv-as="qualification"
                                placeholder="Qualification" v-model="value.optoQualification" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('optoQualification')
                            }">
                            <div v-show="validationErrors.has('optoQualification')" class="invalid-feedback">
                                {{ validationErrors.first('optoQualification') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Awarding Institution</label>
                            <input type="text" name="optoAwardingInstitution" data-vv-validate-on="blur" data-vv-as="awarding institution"
                                placeholder="Awarding Institution" v-model="value.optoAwardingInstitution" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('optoAwardingInstitution')
                            }">
                            <div v-show="validationErrors.has('optoAwardingInstitution')" class="invalid-feedback">
                                {{ validationErrors.first('optoAwardingInstitution') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Malaysian Optical Council (MOC) Registration Number</label>
                            <input type="text" name="optoMalaysiaOpticalCouncilRegistrationNumber" data-vv-validate-on="blur" data-vv-as="Malaysian Optical Council (MOC) registration number"
                                placeholder="Registration Number" v-model="value.optoMalaysiaOpticalCouncilRegistrationNumber" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('optoMalaysiaOpticalCouncilRegistrationNumber')
                            }">
                            <div v-show="validationErrors.has('optoMalaysiaOpticalCouncilRegistrationNumber')" class="invalid-feedback">
                                {{ validationErrors.first('optoMalaysiaOpticalCouncilRegistrationNumber') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Malaysian Optical Council (MOC) Registration Document Upload</label>
                            <div>
                                <div>
                                    <input id="optoMocRegistrationFileInput" type="file" v-validate="'required'" data-vv-as="Malaysian Optical Council (MOC) Registration Document" name="optoMocRegistrationFileInput" :class="{'is-invalid':  validationErrors.has('optoMocRegistrationFileInput')}">
                                    <div v-show="validationErrors.has('optoMocRegistrationFileInput')" class="invalid-feedback">
                                        {{ validationErrors.first('optoMocRegistrationFileInput') }}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>Contact Details</b>
                        </div>

                        <div class="form-group required">
                            <label>Contact Person</label>
                            <input type="text" name="contactPerson" data-vv-validate-on="blur" data-vv-as="contact person"
                                placeholder="Contact Person" v-model="value.contactPerson" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('contactPerson')
                            }">
                            <div v-show="validationErrors.has('contactPerson')" class="invalid-feedback">
                                {{ validationErrors.first('contactPerson') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Contact Person Designation</label>
                            <input type="text" name="contactPersonDesignation" data-vv-validate-on="blur" data-vv-as="contact person designation"
                                placeholder="E.g. Mr., Mrs, Dr., Dato Sri" v-model="value.contactPersonDesignation" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('contactPersonDesignation')
                            }">
                            <div v-show="validationErrors.has('contactPersonDesignation')" class="invalid-feedback">
                                {{ validationErrors.first('contactPersonDesignation') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Practice Phone</label>
                            <input type="text" name="clinicPhone" data-vv-validate-on="blur" data-vv-as="practice phone"
                                placeholder="Practice Phone" v-model="value.clinicPhone" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('clinicPhone')
                            }">
                            <div v-show="validationErrors.has('clinicPhone')" class="invalid-feedback">
                                {{ validationErrors.first('clinicPhone') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Practice Email</label>
                            <input type="text" name="clinicEmail" data-vv-validate-on="blur" data-vv-as="practice email"
                                placeholder="Practice Email" v-model="value.clinicEmail" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('clinicEmail')
                            }">
                            <div v-show="validationErrors.has('clinicEmail')" class="invalid-feedback">
                                {{ validationErrors.first('clinicEmail') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Fax (Optional)</label>
                            <input type="text" name="fax" data-vv-validate-on="blur" data-vv-as="fax"
                                placeholder="Fax" v-model="value.fax" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('fax')
                            }">
                            <div v-show="validationErrors.has('fax')" class="invalid-feedback">
                                {{ validationErrors.first('fax') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Website (Optional)</label>
                            <input type="text" name="website" data-vv-validate-on="blur" data-vv-as="website"
                                placeholder="Website" v-model="value.website" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('website')
                            }">
                            <div v-show="validationErrors.has('website')" class="invalid-feedback">
                                {{ validationErrors.first('website') }}
                            </div>
                        </div>

                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>Location Details</b>
                        </div>

                        <div class="place-map">
                            <div class="mb-2">
                                <p>Adjust red marker to desired location.</p>
                                <p class="text-danger">Click "Get Location" to retrieve latitude and longitude.</p>
                            </div>
                            <div class="place-gmaps-wrapper">
                                <div :id="mapId" class="google-map" :style="
                                {
                                    height:`${mapHeight}px`
                                }">
                                </div>
                                <div class="map-search-wrapper">
                                    <div class="input-group">
                                        <input :id="searchBoxId" type="text" class="form-control mr-1" placeholder="Search location"
                                        v-model="currentAddress">
                                        <div class="input-group-append">
                                            <button class="btn btn-primary" type="button" @click="getGmapLatLng">
                                                Get Location
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="map-edit-cursor"
                                    :style="cursorPosition">
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 font-italic font-weight-bold" style="font-size: 14px;">
                                Auto-filled
                            </div>
                            <div class="form-group required col-12 col-md-6">
                                <label>Latitude</label>
                                <input disabled type="text" name="lat" data-vv-validate-on="blur" data-vv-as="latitude"
                                    placeholder="Latitude" v-model="value.lat" v-validate="'required'" :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('lat')
                                }">
                                <div v-show="validationErrors.has('lat')" class="invalid-feedback">
                                    {{ validationErrors.first('lat') }}
                                </div>
                            </div>

                            <div class="form-group required col-12 col-md-6">
                                <label>Longitude</label>
                                <input disabled type="text" name="long" data-vv-validate-on="blur" data-vv-as="longitude"
                                    placeholder="Longitude" v-model="value.long" v-validate="'required'" :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('long')
                                }">
                                <div v-show="validationErrors.has('long')" class="invalid-feedback">
                                    {{ validationErrors.first('long') }}
                                </div>
                            </div>
                        </div>

                        <div class="font-weight-bold font-italic" style="font-size: 14px; color:red;">
                            Please fill up
                        </div>

                        <div class="form-group required">
                            <label>Address Line 1</label>
                            <input type="text" name="addressLine1" data-vv-validate-on="blur" data-vv-as="address line 1"
                                placeholder="Address Line 1" v-model="value.addressLine1" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('addressLine1')
                            }">
                            <div v-show="validationErrors.has('addressLine1')" class="invalid-feedback">
                                {{ validationErrors.first('addressLine1') }}
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Address Line 2</label>
                            <input type="text" name="addressLine2" data-vv-validate-on="blur" data-vv-as="address line 2"
                                placeholder="Address Line 2" v-model="value.addressLine2" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('addressLine2')
                            }">
                            <div v-show="validationErrors.has('addressLine2')" class="invalid-feedback">
                                {{ validationErrors.first('addressLine2') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>City</label>
                            <input type="text" name="addressCity" data-vv-validate-on="blur" data-vv-as="address city"
                                placeholder="City" v-model="value.addressCity" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('addressCity')
                            }">
                            <div v-show="validationErrors.has('addressCity')" class="invalid-feedback">
                                {{ validationErrors.first('addressCity') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>State</label>
                            <input type="text" name="addressState" data-vv-validate-on="blur" data-vv-as="address state"
                                placeholder="State" v-model="value.addressState" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('addressState')
                            }">
                            <div v-show="validationErrors.has('addressState')" class="invalid-feedback">
                                {{ validationErrors.first('addressState') }}
                            </div>
                        </div>

                        <div class="form-group required">
                            <label>Postcode</label>
                            <input type="text" name="addressPoscode" data-vv-validate-on="blur" data-vv-as="address postcode"
                                placeholder="Postcode" v-model="value.addressPoscode" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('addressPoscode')
                            }">
                            <div v-show="validationErrors.has('addressPoscode')" class="invalid-feedback">
                                {{ validationErrors.first('addressPoscode') }}
                            </div>
                        </div>

                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>Operating Hours</b>
                            <div v-show="workingDaysHasError" class="text-danger">The operationg hours field is required.</div>
                        </div>
                        <input style="opacity:0;" :class="{ 'is-invalid':  workingDaysHasError }">

                        <div class="row mb-3">
                            <div class="form-group d-flex justify-content-between col-12" v-for="workingDay in value.workingDays" :key="workingDay.workingDayId">
                                    <div class="">
                                        <input class="mr-2" type="checkbox" :id="workingDay.text" :value="workingDay.workingDayId" v-model="workingDay.selected">
                                        <label :for="workingDay.text">{{ workingDay.text }}</label>
                                    </div>
                                    <div class="">
                                        <vue-timepicker
                                            input-width="100px"
                                            :disabled="workingDay.selected === false"
                                            format="hh:mm A"
                                            v-model="workingDay.startTime"
                                            hide-clear-button
                                            class="ml-2 mr-2"
                                        >
                                        </vue-timepicker>
                                        to
                                        <vue-timepicker
                                            input-width="100px"
                                            :disabled="workingDay.selected === false"
                                            format="hh:mm A"
                                            class="ml-2 mr-2"
                                            v-model="workingDay.endTime"
                                            hide-clear-button
                                        >
                                        </vue-timepicker>
                                    </div>
                                </div>
                        </div>
                        <div class="form-group">
                            <label>Operating Hours Special Remarks (Optional)</label>
                            <div class="mb-1">
                                <small>E.g.: Lunch hours 12pm - 2pm</small>
                            </div>
                            <input type="text" class="form-control" v-model="value.operatingHoursRemarks">
                        </div>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <div class="mb-2">
                            <b>Facilities & Services</b>
                        </div>

                        <div class="form-group">
                            <div class="row">
                                <div class="col-6 d-flex align-items-start" v-for="facilityAndServiceOption in facilitiesAndServicesOptions" :key="facilityAndServiceOption">
                                    <input type="checkbox" :id="facilityAndServiceOption" :value="facilityAndServiceOption" v-model="value.facilitiesAndServices" class="mt-1">
                                    <label class="ml-2 mb-0" :for="facilityAndServiceOption">{{ facilityAndServiceOption }}</label>
                                </div>
                            </div>

                            <div class="form-group mt-2">
                                <label>Others Tests (Please Specify)</label>
                                <input type="text" name="otherFacilitiesAndServices" data-vv-validate-on="blur" data-vv-as="other facilities and services" placeholder="E.g. Color Vision Testing" v-model="value.otherFacilitiesAndServices" :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('otherFacilitiesAndServices')
                                }">
                                <small>Separate by a comma (,)</small>
                                <div v-show="validationErrors.has('otherFacilitiesAndServices')" class="invalid-feedback">
                                    {{ validationErrors.first('otherFacilitiesAndServices') }}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <template v-if="false">
                    <div class="card mb-3">
                        <div class="card-body">
                            <div class="mb-2">
                                <b>Bank Account Details</b>
                            </div>

                            <div class="form-group">
                                <label>Bank Account Payee Name</label>
                                <input type="text" name="bankAccountPayeeName" data-vv-validate-on="blur" data-vv-as="bank account payee name"
                                    placeholder="Bank Account Payee Name" v-model="value.bankAccountPayeeName" v-validate="'required'" :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('bankAccountPayeeName')
                                }">
                                <div v-show="validationErrors.has('bankAccountPayeeName')" class="invalid-feedback">
                                    {{ validationErrors.first('bankAccountPayeeName') }}
                                </div>
                            </div>

                            <div class="form-group">
                                <label>Bank Name</label>
                                <input type="text" name="bankName" data-vv-validate-on="blur" data-vv-as="bank name"
                                    placeholder="Bank Name" v-model="value.bankName" v-validate="'required'" :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('bankName')
                                }">
                                <div v-show="validationErrors.has('bankName')" class="invalid-feedback">
                                    {{ validationErrors.first('bankName') }}
                                </div>
                            </div>

                            <div class="form-group">
                                <label>Bank Account Number</label>
                                <input type="text" name="bankAccountNumber" data-vv-validate-on="blur" data-vv-as="bank account number"
                                    placeholder="Bank Account Number" v-model="value.bankAccountNumber" v-validate="'required'" :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('bankAccountNumber')
                                }">
                                <div v-show="validationErrors.has('bankAccountNumber')" class="invalid-feedback">
                                    {{ validationErrors.first('bankAccountNumber') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </form>
    </div>
</template>

<script>
/* global google */
import { googleMapsConfig } from '@/config/';
import { generateRandomId } from '@/utilities/';
import multipleSelectDropdown from '@/components/multiple-select-dropdown';
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue';
import facilitiesAndServicesOptions from '@/config/optometristFacilitiesAndServices';
import languages from '@/config/languages';
import {
    mask
} from 'vue-the-mask';

export default {
    'name': 'RegisterOptometristComponent',
    'components': {
        multipleSelectDropdown,
        VueTimepicker
    },
    'directives': {
        mask
    },
    'props': {
        'value': Object
    },
    'computed': {
        mapHeight () {
            return this.mapWidth;
        },
        cursorPosition () {
            let cursorWidth = 48;
            let tipOffset = 20;

            return {
                'left': `${(this.mapHeight / 2) - (cursorWidth / 2)}px`,
                'top': `${((this.mapHeight / 2) - (cursorWidth / 2)) - tipOffset}px`
            };
        }
    },
    data () {
        return {
            facilitiesAndServicesOptions,
            languages,
            'mapId': '',
            'mapDom': null,
            'searchBoxId': '',
            'searchBoxDom': null,
            'googleMapObj': null,
            'googleMapsAutoComplete': null,
            'currentAddress': '',
            'mapWidth': '',
            'workingDaysHasError': false,
            'languagesSpeakHasError': false
        };
    },
    'watch': {
        mapHeight () {
            this.$nextTick(() => {
                this.googleMapsResizeHandler();
            });
        }
    },
    'methods': {
        validate () {
            let workingDayCount = 7;

            for (const workingDay of this.value.workingDays) {
                if (workingDay.selected === false) {
                    workingDayCount--;
                }
            }

            if (workingDayCount <= 0) {
                this.workingDaysHasError = true;
                return Promise.resolve(false);
            }

            if (this.value.languagesSpeak.length === 0) {
                this.languagesSpeakHasError = true;
                return Promise.resolve(false);
            } else {
                this.languagesSpeakHasError = false;
            }

            return this.$validator.validateAll();
        },
        updateWorkingDays (selectedValue) {
            // find index of selectedItem
            let selectedIndex = this.value.workingDays.findIndex((s) => s === selectedValue);

            if (selectedIndex > -1) {
                this.value.workingDays.splice(selectedIndex, 1);
            } else {
                this.value.workingDays.push(selectedValue);
            }

            this.value.workingDays.sort((a, b) => (a.DayId > b.DayId) ? 1 : ((b.DayId > a.DayId) ? -1 : 0));
        },
        getDayText (DayId) {
            const workingDay = this.workingDays.find(workingDay => workingDay.value.DayId === DayId);

            return workingDay.text;
        },
        initGoogleMaps () {
            this.googleMapObj = new google.maps.Map(this.mapDOM, googleMapsConfig);

            // Init search box, restrict places to Malaysia only.
            this.googleMapsAutoComplete = new google.maps.places.Autocomplete(this.searchBoxDOM);
            this.googleMapsAutoComplete.setComponentRestrictions({ 'country': 'my' });

            this.googleMapsAutoComplete.addListener('place_changed', () => {
                let place = this.googleMapsAutoComplete.getPlace();
                let placeGeometry = place.geometry;

                // this.form.searchLocation = place.name;
                if (placeGeometry) {
                    this.googleMapObj.setCenter(placeGeometry.location);
                }
            });

            this.googleMapObj.addListener('click', (event) => {
                this.googleMapObj.setCenter(event.latLng);
            });

            // Bias the SearchBox results towards current map's viewport.
            this.googleMapObj.addListener('bounds_changed', () => {
                this.googleMapsAutoComplete.setBounds(this.googleMapObj.getBounds());
            });
        },
        googleMapsResizeHandler () {
            if (this.googleMapObj) {
                google.maps.event.trigger(this.googleMapObj, 'resize');
            }
        },
        windowResizeHandler () {
            this.mapWidth = this.mapDOM.getBoundingClientRect().width;
        },
        getGmapLatLng () {
            if (this.googleMapObj) {
                let latLng = this.googleMapObj.getCenter();
                this.value.lat = latLng.lat();
                this.value.long = latLng.lng();
            }
        }
    },
    created () {
        this.mapId = generateRandomId();
        this.searchBoxId = generateRandomId();
    },
    mounted () {
        window.addEventListener('resize', this.windowResizeHandler);
        window.addEventListener('orientationchange', this.windowResizeHandler);

        this.mapDOM = document.getElementById(this.mapId);
        this.searchBoxDOM = document.getElementById(this.searchBoxId);
        this.mapWidth = this.mapDOM.getBoundingClientRect().width;

        this.initGoogleMaps();
    },
    destroyed () {
        window.removeEventListener('resize', this.windowResizeHandler);
        window.removeEventListener('orientationchange', this.windowResizeHandler);
    }
};
</script>

<style scoped>
/*Place Detail*/
.place-map
{
    margin-bottom: 1rem;
}

.place-map > .place-gmaps-wrapper {
    position: relative;
}

.place-map .map-search-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 1em 1em 0 1em;
}

.place-map .map-edit-cursor {
    position: absolute;
    top: 0;
    width: 48px;
    height: 48px;
    background-image: url("../../assets/img/icons/location_edit.svg");
    background-size: 48px 48px;
    background-position: top left;
    background-repeat: no-repeat;
}

/* .place-map  .map-no-edit {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
} */
/*Place Detail*/
</style>
